import { createContext, useState } from 'react'
import ReactPlayer from 'react-player/file'

import AdminEditItemLink from './components/AdminEditItemLink'
import UserLink from './components/UserLink'
import { Cell } from '../components'

import closeImg from '../images/close.svg'

export const AdminAudioPlayerContext = createContext('admin-audio-player-context')

export const AdminAudioPlayerContextProvider = ({children}) => {
  const [currentAudio, setCurrentAudio] = useState({})

  const playItem = ({fileSrc, streamSrc, name, itemType, itemId, username, userId, images}) => {
    setCurrentAudio({fileSrc, streamSrc, name, itemType, itemId, username, userId, images, playing: true})
  }

  const isItemPlaying = (itemType, itemId) => {
    return currentAudio.itemType === itemType && currentAudio.itemId === itemId && currentAudio.playing;
  }

  const pauseItem = (itemType, itemId) => {
    if (isItemPlaying(itemType, itemId)) {
      setPaused()
    }
  }

  const setPlaying = () => {
    setCurrentAudio({...currentAudio, playing: true})
  }

  const setPaused = () => {
    setCurrentAudio({...currentAudio, playing: false})
  }

  const close = () => {
    setCurrentAudio({})
  }

  const targetSrc = currentAudio.streamSrc || currentAudio.fileSrc;

  return (
    <AdminAudioPlayerContext.Provider
      value={{
        playItem,
        isItemPlaying,
        pauseItem,
      }}
    >
      <div style={{marginBottom: '100px'}}>
        {children}
      </div>

      {targetSrc &&
        <div className='admin-audio-player'>
          <Cell noline>
            <Cell.Image src={currentAudio.images && currentAudio.images['400']} alt='' small />

            <Cell.Body>
              <Cell.Line>
                <Cell.LineTitle>
                  <AdminEditItemLink item_name={currentAudio.name} item_type={currentAudio.itemType} item_id={currentAudio.itemId} />
                </Cell.LineTitle>
              </Cell.Line>
              <Cell.Line>
                <UserLink user_id={currentAudio.userId} username={currentAudio.username} />
              </Cell.Line>
              <Cell.Line>
                <ReactPlayer
                  controls
                  playing={currentAudio.playing}
                  className='cell__audioPlayer'
                  url={targetSrc}
                  height="20px"
                  width="300px"
                  onPause={setPaused}
                  onPlay={setPlaying}
                />
              </Cell.Line>
            </Cell.Body>

            <button className='close' onClick={close}>
              <img src={closeImg} alt='Close' />
            </button>
          </Cell>
        </div>}
  </AdminAudioPlayerContext.Provider>)
}
